import { Button } from '@/components/ui/Button';
import { PosCustomerPanel } from '@/components/pos/PosCustomerPanel';
import { usePosBilling } from '@/pages/pos/PosBillingContext';

export function PosSummaryPane() {
  const {
    cart,
    openPayment,
    holdBill,
    openDiscount,
    setHelpOpen,
    setCustomerId,
    currencyCode,
  } = usePosBilling();

  return (
    <aside className="flex w-[320px] shrink-0 flex-col border-l border-slate-300 bg-slate-50 dark:border-slate-700 dark:bg-slate-900">
      <PosCustomerPanel currencyCode={currencyCode} onCustomerChange={setCustomerId} />
      <div className="border-b border-slate-200 px-3 py-2 dark:border-slate-700">
        <h3 className="text-xs font-bold uppercase tracking-wide text-slate-500">Quick actions</h3>
        <div className="mt-2 grid grid-cols-2 gap-2">
          <Button variant="secondary" onClick={holdBill} disabled={!cart.items.length}>
            Hold bill
          </Button>
          <Button onClick={openPayment} disabled={!cart.items.length}>
            Payment
          </Button>
          <Button variant="secondary" onClick={openDiscount}>
            Discount
          </Button>
          <Button variant="secondary" onClick={() => setHelpOpen(true)}>
            Shortcuts guide
          </Button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-3">
        <div className="rounded-lg border border-slate-200 bg-white p-3 text-xs text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400">
          <p className="font-semibold text-slate-800 dark:text-slate-200">Keyboard-first billing</p>
          <p className="mt-2 leading-relaxed">
            Use function keys for search, payment, hold, and discounts. Open the shortcuts guide for the full list.
          </p>
        </div>
      </div>
    </aside>
  );
}
